export default "__VITE_ASSET__Cw0NmtA1__"